export default {
  "iso3": "eng",
  "iso2": "en",
  "text": {
    "100200": "We're sorry, this game seems to be restricted in your area.",
    "CURRENT_LANGUAGE": "English",
    "CIP8_TITLE": "888CASINO GAMES",
    "Login": "LOG IN",
    "WITHDRAW": "WITHDRAW",
    "CASHIER": "CASHIER",
    "Search": "Search your game...",
    "REWARDS": "Rewards",
    "HOME": "Home",
    "888_COM": "888.com",
    "888_POKER": "poker",
    "888_CASINO": "casino",
    "888_BINGO": "bingo",
    "888_SPORT": "sport",
    "SIGN_UP": "SIGN UP",
    "GET_APP": "GET THE APP",
    "DEPOSIT_SIDE_MENU": "Deposit",
    "MY_ACCOUNT": "MY ACCOUNT",
    "BALANCE": "Your Balance",
    "MINI_ORBIT_BALANCE": "Balance:",
    "LOGOUT": "Log out",
    "GREETING_MORNING": "Good Morning",
    "GREETING_AFTERNOON": "Good Afternoon",
    "GREETING_EVENING": "Good Evening",
    "GREETING_NIGHT": "Good Night",
    "GREETING_DEFAULT": "Hello",
    "MRS_TITLE": "Mrs.",
    "MR_TITLE": "Mr.",
    "SLOTS": "Slots",
    "LOBBY": "Lobby",
    "SLOTS_JACKPOTS": "Slots & Jackpots",
    "CARD_TABLE_GAMES": "Card & Table Games",
    "ALL_SDM_GAMES": "All SDM Games",
    "CASINO_GAMES": "Casino Games",
    "LIVE_CASINO": "Live Casino",
    "888_EXCLUSIVE_GAMES": "888 Exclusive Games",
    "PROMOTIONS": "Promotions",
    "888SPORT": "888sport",
    "VIP_CLUB": "VIP Club",
    "PWA_INSTALL": "Install App",
    "PWA_ADD_TO_HOME_SCREEN": "Add to Home Screen",
    "PWA_TAP": "Tap",
    "PWA_QUICK_LAUNCH": "Quick launch {BRAND}",
    "GETTING_STARTED": "Getting Started",
    "BANKING": "Banking",
    "VIP": "VIP",
    "BLOG": "Blog",
    "TODAY_WINNERS": "Today’s Winners",
    "SUPPORT_ID_MESSAGE": "Support ID",
    "DEPOSIT": "DEPOSIT",
    "CHOOSE_LANG": "Choose your language:",
    "CHOOSE_COUNTRY": "Choose your country:",
    "SIGN_IN_PLAY": "SIGN IN & PLAY",
    "NEW": "New",
    "JACKPOT": "Jackpot",
    "EXCLUSIVE": "888 Exclusive",
    "SI_EXCLUSIVE": "SI Exclusive",
    "1-25_LINES": "1-25 Lines",
    "25+_LINES": "25+ Lines",
    "INFO_TITLE_ARENA_888_EXCLUSIVE_GAMES": "Exclusive Games",
    "INFO_TEXT_ARENA_888_EXCLUSIVE_GAMES": "888casino is home to an exclusive selection of online casino games. Play the hottest online slots from Section8, and enjoy fantastic casino games like online Roulette, online Blackjack and Video Poker. Our exclusive casino games also include Baccarat, Keno, and instant win games. Let’s get ready for some casino fun!",
    "INFO_TITLE_ARENA_SLOTS": "Online Slots",
    "INFO_TITLE_ARENA_VIDEO_SLOTS": "Video Slots",
    "INFO_TEXT_ARENA_SLOTS": "Choose from over 1000 of the best quality slot games, anywhere online. Enjoy a wide variety of features such as Bonus Games, Expanding Wilds, Free Spins and Huge Jackpots. Hunt for treasure in ancient Egypt, uncover the Leprechaun’s coveted pot o’ gold or spin for big wins on classic fruit machines. Whatever tickles your fancy, we’ve got it!",
    "INFO_TITLE_ARENA_CASINO": "Casino Games",
    "INFO_TEXT_ARENA_CASINO": "The cards are shuffled, the wheel is spinning and your seat is waiting. Play only the very best card and table games online. Choose from a variety of Roulette games including European, American, Low, High and Super Stakes. Prefer Blackjack? Play multiple hands at the same time. From Texas Hold’em to Caribbean, be sure to find your poker preference!",
    "INFO_TITLE_ARENA_ROULETTE": "Roulette Online",
    "INFO_TEXT_ARENA_ROULETTE": "Try to hit your lucky numbers at one of 888casino’s premier online roulette tables. Choose from our wide variety of top roulette game styles including European, American and French. Whether you’re a High Roller or prefer low stakes, there’s a roulette game for you. There’s nothing like the thrill of waiting for that ball to land when you play roulette!",
    "INFO_TITLE_ARENA_NEW_GAMES": "New Games",
    "INFO_TEXT_ARENA_NEW_GAMES": " ",
    "INFO_TITLE_ARENA_BLACKJACK": "Blackjack Online",
    "INFO_TEXT_ARENA_BLACKJACK": "The cards are shuffled and your seat is waiting for some of the best online blackjack games you’ll find! Play blackjack at 888casino on your own terms with Super Stakes, Side Bets and more. One hand of blackjack not enough for you? Play our Multihand Blackjack game for three chances to hit 21, at the same time!",
    "INFO_TITLE_ARENA_VIDEO_POKER": "Video Poker Online",
    "INFO_TEXT_ARENA_VIDEO_POKER": "If you think you’re a real poker pro then you’ve come to the right casino! Go for that elusive Royal Flush in our various types of video poker games. If you’re into 5-card draw or prefer the ever-popular Texas Hold’em then you’re sure to find your new favourite online video poker game at 888casino.",
    "INFO_TITLE_ARENA_SCRATCH_CARDS": "Scratch Cards Online",
    "INFO_TEXT_ARENA_SCRATCH_CARDS": "There’s nothing like a quick win on one of 888casino’s exciting scratch card games. Ideal for some strategy-free fun, pick an online scratch card in the theme of your choice. Reveal your Irish riches or discover pharaoh’s fortune, it’s up to you. Simply choose the amount you want to bet and see if you’re a scratch card winner!",
    "INFO_TITLE_ARENA_JACKPOTS": "Jackpots",
    "INFO_TEXT_ARENA_JACKPOTS": "Jackpot games are bubbling over with unbelievably huge cash prizes. Play with our slots games and you’re in lots of joy and fun. These include daily jackpots, progressive jackpots, and pooled jackpots, you are one click away from the absolute perfect play; enjoy jackpot slots games like Millionaire Genie, Mermaid’s Millions, or Noche De Los Muertos. Click it to pick it. Spin it to try your luck to win it. The fun starts NOW!",
    "INFO_TITLE_ARENA_ALL_GAMES": "All Games",
    "VIRTUAL_SPORTS": "Virtual Sports",
    "INFO_TITLE_ARENA_VIRTUAL_SPORTS": "Virtual Sports",
    "INFO_TEXT_ARENA_VIRTUAL_SPORTS": "Virtual Sports brings you a wide variety of computer-generated sports games that you’ll be able to bet on. So, whether football's your thing, or darts, or anything else, you can be sure to find what you're looking for. Enter the world of virtual betting today.",
    "PROMO_ELIGIBLE_GAMES": "Promo Eligible Games",
    "NETENT_SLOTS": "NETENT SLOTS",
    "BONUS": "Bonus",
    "FREE_SPINS": "Free Spins",
    "CLEAR_ALL": "Clear All",
    "FILTER": "Filter",
    "APPLY": "Apply",
    "ROULETTE": "Roulette",
    "ELITE_LOUNGE": "Elite Lounge",
    "BLACKJACK": "Blackjack",
    "PROGRESSIVE_SLOTS": "Progressive Slots",
    "BACCARAT": "Baccarat",
    "POKER": "Poker",
    "KENO": "Keno",
    "HIGH_LIMIT": "High Limit",
    "LANGUAGES": "Languages",
    "HELP": "Help",
    "LIVE_CHAT": "Live Chat",
    "DEMO": "Demo",
    "PLAY": "Play",
    "NOT_NOW": "Not now",
    "NO_THANKS": "No, thanks",
    "LETS_PLAY": "Let's Play!",
    "GOT_IT": "GOT IT!",
    "LIMITS": "Limits",
    "LIVE": "Live",
    "SEE_ALL": "See All",
    "WINNING_IN_THE_LAST_30_DAYS": "Winning in the last 30 days",
    "TOTAL_JACKPOTS": "Total Jackpots",
    "TOP_GAMES": "TOP SLOT GAMES",
    "TOP_PROGRESSIVES": "TOP PROGRESSIVES",
    "LIVE_CASINO_TABLES": "SELECTED LIVE TABLES",
    "TOP_CASINO_GAMES": "TOP CASINO GAMES",
    "JACKPOTS": "JACKPOTS",
    "RECENTLY_PLAYED": "Recently Played",
    "BECAUSE_YOU_PLAYED": "Because You Played {gameName}",
    "MINIMUM_BET": "Min Bet",
    "MAXIMUM_BET": "Max Bet",
    "PAYLINES": "Paylines",
    "BONUS_GAME": "Bonus game",
    "MAX_PER_SPOT": "Max Per Spot",
    "MULTIPLAYER": "Multiplayer",
    "MULTIHAND": "Multihand",
    "DECKS": "Decks",
    "SIDE_BETS": "Side Bets",
    "ABOUT": "About",
    "GAME_JACKPOT": "Game Jackpot",
    "SLOT_GAMES": "Slot Games",
    "CARD_AND_TABLE_GAMES": "Card & Table Games",
    "JACKPOT_GAMES": "Jackpot Games",
    "JACKPOT_CENTRAL": "Jackpot Central",
    "OTHER": "Other",
    "POKER_GAMES": "POKER GAMES",
    "YOUR_SEARCH_DID_NOT_MATCH_ANY_GAMES": "Your search did not match any games",
    "PREMIER_ONLINE_LIVE_CASINO": "Premier live casino",
    "All_SLOTS": "All Slots",
    "All_CARD_AND_TABLE_GAMES": "All Card & Table Games",
    "USEFUL_LINKS": "Useful links",
    "PRIVACY_POLICY": "Privacy Policy",
    "USER_AGREEMENT": "User Agreement",
    "RESPONSIBLE_GAMBLING": "Responsible Gambling",
    "SAFE_ZONE": "Control Center",
    "CONTACT": "Contact Us",
    "COMP_POINTS": "Comp Points",
    "GAMING_HISTORY": "Gaming History",
    "CASHIER_HISTORY": "Cashier History",
    "GAMING_SESSION_HISTORY": "Session History",
    "MY_CHALLENGES": "My Challenges",
    "SCRATCHCARDS": "SCRATCH CARDS",
    "QUICK_LINKS_TITLE": "QUICK LINKS",
    "NO_SEARCH_RESULTS": "No Search Results Found...",
    "SEARCH_YOUR_GAME": "Search for games...",
    "SEARCH_RESULTS_TITLE": "TOP SEARCH RESULTS",
    "SUGGESTED_GAMES": "SUGGESTED GAMES",
    "SUGGESTED_CATEGORIES": "SUGGESTED CATEGORIES",
    "BACK": "Back",
    "HIT_THE_JACKPOT": "Hit The Jackpot",
    "OUR_JACKPOTS": "OUR JACKPOTS",
    "MY_CLUB": "My Club",
    "LOW_ROLLERS": "Low Rollers",
    "CASH_BALANCE": "Cash Balance",
    "BONUS_BALANCE": "Bonus Balance",
    "YOU_MAY_LIKE": "YOU MAY LIKE",
    "TOP_PICKS_FOR": "TOP PICKS FOR {USERNAME}",
    "888CLUB": "888club",
    "888POKER": "888poker",
    "BACK_TO_888POKER": "Back to 888poker",
    "BACK_TO_888SPORT": "Back to 888sport",
    "VIDEO_POKER_GAMES": "Video Poker Games",
    "VIDEO_POKER": "Video Poker",
    "SEO_IMAGE_CATEGORIES_TITLE": "Best {categoryName} experience at 888casino",
    "SEO_IMAGE_CATEGORIES_ALT": "online casino - {categoryName}",
    "SEO_IMAGE_GAME_TITLE": "{gameName} {categoryName}",
    "TOP_NETENT_SLOTS": "TOP NETENT SLOTS",
    "PLAY_50_FREESPINS": "PLAY 50 FREESPINS",
    "HOLIDAY_GAMES": "HOLIDAY GAMES",
    "ORIGINALS": "888 Originals",
    "RELATED_GAMES": "BECAUSE YOU PICKED: {gameName}",
    "DAILY_JACKPOT_GAMES": "Daily Jackpot Games",
    "LOW_STAKES": "Low Stakes",
    "TOP_EXCLUSIVE_SLOTS": "Top Exclusive Slots",
    "TOP_10_IN_YOUR_COUNTRY": "Top 10 in your country",
    "NEW_GAMES": "New Games",
    "DAILY_JACKPOT": "Daily Jackpot",
    "PROGRESSIVE_JACKPOT": "Progressive Jackpot",
    "777_JUKEBOX": "777 Jukebox",
    "RETRO_SLOTS": "Retro Slots",
    "SELECTED_LIVE_CASINO_TABLES": "Selected Live Casino Tables",
    "BLACKJACK_GAMES": "Blackjack Games",
    "ROULETTE_GAMES": "Roulette Games",
    "DROP_THE_JACKPOT": "Drop The Jackpot",
    "777_LIVE": "777 Live",
    "ROULETTE_&_BLACKJACK": "Roulette & Blackjack",
    "SCRATCH_CARDS": "Scratch Cards",
    "CLASSIC_SLOTS": "Classic Slots",
    "777_FAVORITES": "777 Favorites",
    "FEATURED": "Featured",
    "LOW_VOLATILITY": "Low Volatility",
    "HIGH_VOLATILITY": "High Volatility",
    "IN_HOUSE_SLOTS": "In House Slots",
    "MORE_GAMES": "More Games",
    "ALL_JACKPOTS": "All Jackpots",
    "ONLINE_JACKPOTS": "Online Jackpots",
    "All_GAMES": "All Games",
    "POPULAR_GAMES_TITLE": "Popular Games",
    "MORE": "More",
    "HOMEPAGE-SPOOKY_SPINS": "Spooky Spins",
    "THE_DAILY_JACKPOT": "888 Daily Jackpot",
    "HIGH_NOON_JACKPOT": "High Noon Jackpot",
    "TWILIGHT_JACKPOT": "Twilight Jackpot",
    "POWER8_JACKPOT": "POWER 8 JACKPOT",
    "RED_TIGER_DAILY_JACKPOT": "Red Tiger's Daily Jackpot",
    "RED_TIGER_HOURLY_JACKPOT": "Red Tiger Hourly Jackpot",
    "PROGRESSIVE_JACKPOTS": "Progressive Jackpots",
    "INSTANT_GAMES": "Instant Win Games",
    "INSTANT_WIN_GAMES_ARENA": "Instant Win Games",
    "ALL_INSTANT_WIN_GAMES": "All Instant Win Games",
    "INFO_TITLE_ARENA_INSTANT_WIN_GAMES": "Instant Win Games",
    "INFO_TEXT_ARENA_INSTANT_WIN_GAMES": "Instant Win Games are so much FUN! Get ready to scratch & match with the best scratch cards under the sun. We’ve got many games for you to enjoy like Volcano Eruption, Panda Mania, and Merlin’s Millions. Short on time? No worries, try our Keno and Bingo games, or sizzling-hot new games like Chicken Extreme, 7-UP, and Epic Gems. It’s a party and you’re invited. Instant Win Games are really easy to play. No skills needed – just play & win!",
    "MEGAWAYS_TITLE": "Megaways™",
    "TRENDING_SLOTS": "TRENDING SLOTS",
    "EXCLUSIVE_LIVE_TABLES": "EXCLUSIVE LIVE TABLES",
    "BLACKJACK_AND_ROULETTE_GAMES": "BLACKJACK & ROULETTE GAMES",
    "ALL_888_EXCLUSIVE_GAMES": "ALL 888 EXCLUSIVE GAMES",
    "LIVE_ARENA_TABLE_IS_CLOSED_MESSAGE": "Table Opens at",
    "LIVE_CASINO_TABLE_FULL_PC": "Table Full",
    "LIVE_CASINO_TABLE_FULL_MOBILE": "Full",
    "GAME_SHOWS": "Game Shows",
    "TOP_EVO_GAMES": "Top Games",
    "FOR_YOU_GAMES": "For You",
    "AB_TEST_AI_LIST_TITLE_D1_V1": "Top Rated Games for {USERNAME}",
    "AB_TEST_AI_LIST_TITLE_D1_V2": "Recommended games for {USERNAME}",
    "AB_TEST_AI_LIST_TITLE_D3_V1": "Selected Games for {USERNAME}",
    "AB_TEST_AI_LIST_TITLE_D3_V2": "Chosen Games for {USERNAME}",
    "AB_TEST_AI_LIST_TITLE_D3_V3": "Exclusive games for {USERNAME}",
    "AB_TEST_AI_LIST_TITLE_D3_V4": "Recommended games for you",
    "LETS_PLAY_MONOPOLY": "Let's play Monopoly",
    "TOP_TRENDING_SLOTS": "Top Trending Slots",
    "TOP_PAYING_SLOTS": "Top Paying Slots",
    "RECENTLY_ADDED": "Recently Added",
    "TOP_SLOTS": "Top Slots",
    "REAL_MONEY_GAME": "This game can be played with cash balance only.",
    "CANT_CONNECT_ERROR_TITLE": "Can't connect",
    "CANT_CONNECT_ERROR_MESSAGE": "Sorry, something went wrong on our end.",
    "RETRY": "Retry",
    "TRANSACTION_HISTORY": "Transaction History",
    "BRAND_NEW": "Brand New",
    "HOTTEST_NEW_GAMES": "Hottest new games",
    "SINCE_LAST_MONTH": "Since Last Month",
    "SAFE_GAMBLING_TOOLTIP": "Safer Gambling Tools & Information",
    "PLAYER_LIMITS_TOASTER_TITLE": "Your Limits",
    "PLAYER_LIMITS_TOASTER_DAILY_LABEL": "Daily",
    "PLAYER_LIMITS_TOASTER_WEEKLY_LABEL": "Weekly",
    "PLAYER_LIMITS_TOASTER_MONTHLY_LABEL": "Monthly",
    "PLAYER_LIMITS_TOASTER_DEPOSIT_LABEL": "Deposit",
    "PLAYER_LIMITS_TOASTER_PLAY_TIME_LABEL": "Play Time",
    "PLAYER_LIMITS_TOASTER_BANKROLL_LABEL": "Bankroll",
    "PLAYER_LIMITS_TOASTER_HOUR_LABEL": "hour",
    "GAME_POPUP_TITLE": "Welcome back",
    "GAME_POPUP_SUB_TITLE": "Suggested game",
    "GAME_POPUP_DESCRIPTION": "Your 888slots activity:",
    "GAME_POPUP_GAME_UNAVAILABLE": "Sorry, this game is unavailable",
    "GAME_POPUP_MAY_LIKE": "You may also like",
    "PARTY_JACKPOT_WELCOME_POPUP_TITLE": "HOORAY! You’re about to play a {partyJackpotName} game!",
    "PARTY_JACKPOT_WELCOME_POPUP_TITLE_ALL_LIVE_CASINO": "LUCKY YOU!",
    "PARTY_JACKPOT_WELCOME_POPUP_SUB_TITLE_ALL_LIVE_CASINO": "All Live Casino games are part of our HOT NEW jackpot!",
    "PARTY_JACKPOT_WELCOME_POPUP_DESCRIPTION": "The Jackpot can be won on any cash balance bet.\nAll Party Jackpot prizes are bonuses, which are instantly credited to your account.",
    "PARTY_JACKPOT_WELCOME_POPUP_DESCRIPTION_REAL": "Any real money bet on a Party Jackpot game could win a cash prize!\nThe Party Jackpot will pay daily!",
    "PARTY_JACKPOT_WELCOME_POPUP_DESCRIPTION_REAL_HOURLY": "Any real money bet on a Party Jackpot game could win a cash prize!\nThe Party Jackpot will pay hourly between {startHour} to {endHour}",
    "PARTY_JACKPOT_WELCOME_POPUP_DESCRIPTION_REAL_HOURLY_ALL_LIVE_CASINO": "Real money bets on any Live Casino game could win the jackpot!\nThe Live Casino Jackpot must pay every hour, {startHour} - {endHour}, and is fully funded by us.",
    "PARTY_JACKPOT_WELCOME_POPUP_BOTTOM_NOTE": "Bonus: wager 30x (varies by game type), 90 day expiry, wins capped at $500, valid for selected games",
    "PARTY_JACKPOT_WELCOME_POPUP_BOTTOM_NOTE_REAL": "Funded players only",
    "PARTY_JACKPOT_WELCOME_POPUP_TERMS_AND_CONDITIONS_APPLY": "T&C Apply.",
    "PARTY_JACKPOT_WIN_TOASTER_TITLE": "The {jackpotName} just dropped at {winAmount}!",
    "PARTY_JACKPOT_WIN_TOASTER_SUBTITLE": "Didn’t win? No worries!\n This jackpot drops every hour, {startHour}-{endHour}.",
    "PARTY_JACKPOT_WIN_POPUP_YOU_WON": "YOU WON THE {jackpotName}",
    "PARTY_JACKPOT_WIN_POPUP_AWESOME": "AWESOME!",
    "PARTY_JACKPOT_OUT_OF_CASH_TOASTER_TITLE": "Top up to play the Live Casino Jackpot",
    "PARTY_JACKPOT_OUT_OF_CASH_TOASTER_SUBTITLE": "The Live Casino Jackpot can only be won with real money",
    "JACKPOT-WIDGET-MUST-PAY": "Must Pay within:",
    "JACKPOT-WIDGET-DROPS-SOON": "DROPS SOON!",
    "JACKPOT-WIDGET-STARTS-SOON": "STARTS SOON",
    "JACKPOT-WIDGET-NEXT-JACKPOT": "Launching Next Jackpot",
    "JACKPOT-WIDGET-LAST-WIN": "Last win",
    "IN-GAME-WIDGET-STARTS-SOON": "Starts Soon",
    "FREEPLAY_INDICATOR": "FreePlay",
    "OMG_INDICATOR": "Notifications",
    "USER_LIKE_YOU": "TOP {topNumber} IN {countryName}",
    "YOUR_COUNTRY": "Your country",
    "SOURCE_OF_FUNDS_TITLE": "Important Info Needed",
    "SOURCE_OF_FUNDS_MESSAGE1": "Hi, welcome back!",
    "SOURCE_OF_FUNDS_MESSAGE2": "We just need some info from you. It won't take long at all!",
    "SOURCE_OF_FUNDS_OPEN_CHAT_BTN": "LET'S CHAT",
    "CLOSE": "Close",
    "LIVE_STREAM_WATCH_TIME_REACHED": "Ready to dive in and play?",
    "LIVE_STREAM_VIDEO_LOADING": "Loading…",
    "PLAY_NOW": "PLAY NOW",
    "CASINO": "CASINO",
    "UK_TSR_CONTINUE_OPT": "Continue",
    "UK_TSR_REVIEW_REMINDERS_OPT": "Review reminders",
    "UK_TSR_LOGOUT_OPT": "Logout",
    "UK_TSR_RESUME_GAME_OPT": "Resume Game",
    "UK_TSR_STOP_REMINDERS_OPT": "Stop all game time reminders",
    "UK_TSR_HISTORY_OPT": "View History",
    "UK_TSR_CLOSE_GAME_OPT": "Close Game",
    "TSR_CONFIRM": "OK",
    "TSR_SESSION_TIME_TEXT": "You have been logged in for:",
    "TSR_SUBTEXT": "What would you like to do?",
    "TSR_TITLE": "Time Spent Reminder",
    "TSR_MENU_LINK_LABEL": "Time Spent Reminder",
    "PAYMENTS_REDIRECT_FOCUS_TITLE": "Deposit in process",
    "PAYMENTS_REDIRECT_FOCUS_TEXT": "Your {mftName} screen is still open",
    "PAYMENTS_REDIRECT_FOCUS_CTA": "Continue",
    "VOLATILE_SLOTS": "Volatile Slots",
    "VOLATILE_GAMES": "Volatile Games",
    "HIGH_VOLATILITY_SLOTS": "High Volatility Slots",
    "LOW_VOLATILITY_SLOTS": "Low Volatility Slots",
    "STATE_POPUP_TITLE": "Verify Your Location",
    "STATE_POPUP_HEADER": "Please confirm that you're located in {THE_STATE}",
    "STATE_POPUP_OUTSIDE_TEXT": "I'm located outside of {THE_STATE}",
    "STATE_POPUP_CONFIRM": "Confirm",
    "BURNOUT_MESSAGE_LINE_1": "SURPRISE!",
    "BURNOUT_MESSAGE_LINE_2": "YOU GOT A BONUS!",
    "CONGRATS": "Congrats!",
    "YOUR_FP_ARE_WAITING": "Your FreePlay are waiting for you here",
    "EXIT_POPUP_TITLE": "YOU MAY ALSO LIKE",
    "DONT_SHOW_AGAIN_TEXT": "Don't show again",
    "DAILY_DEAL_WIDGET_STRIP": "I GIORNALIERI",
    "GAMING_HISTORY_NO_RECORDS": "We were unable to locate any history records of your games",
    "GAMING_HISTORY_LAST_PAGE": "No more history records found.",
    "GAMING_HISTORY_BET": "Bet",
    "GAMING_HISTORY_WINNINGS": "Winnings",
    "GAMING_HISTORY_WINNINGS_BONUS_CAP": "Winnings*",
    "GAMING_HISTORY_BANKROLL": "Bankroll",
    "GAMING_HISTORY_MORE_DETAILS": "More Details",
    "GAMING_HISTORY_MORE_DETAILS_NOT_AVAILABLE_PC": "Available only on Mobile devices",
    "GAMING_HISTORY_MORE_DETAILS_NOT_AVAILABLE_MOBILE": "Available only on PC",
    "GAMING_HISTORY_FREE_PLAY_BET": "Bet*",
    "GAMING_HISTORY_FREE_PLAY_WINNINGS": "Winnings*",
    "GAMING_HISTORY_FREE_PLAY_REWARD_WINNINGS": "Reward winnings",
    "GAMING_HISTORY_FREE_PLAY_REWARD_BANKROLL": "Reward bankroll",
    "GAMING_HISTORY_FREE_PLAY_INDICATION": "*Played with rewards",
    "GAMING_HISTORY_FREE_PLAY_MAX_CUP_INDICATION": "*Maximum win",
    "GAMING_HISTORY_BIG_WIN_TAX_INDICATION": "Pending IRS form W-2G completion",
    "GAMING_HISTORY_DAYS_INTERVAL": "Last {numberOfDays} Days",
    "GAME_PARTICIPATION_ID": "Participation ID: {participationID}",
    "GAME_SESSION_ID": "Session ID: {sessionID}",
    "HISTORY_GAME_SESSION_TOTAL_BETS": "Total bets",
    "HISTORY_GAME_SESSION_TOTAL_WINNINGS": "Total wins",
    "HISTORY_GAME_SESSION_BALANCE": "Session Balance",
    "FILTER_GROUP_VENDOR_TYPE": "Vendor Name",
    "GAME_WINDOW_VENDOR_SESSION_ID": "Session ID: {sessionID}",
    "GAME_WINDOW_MODE_REAL_LABEL": "Real Money",
    "GAME_WINDOW_MODE_DEMO_LABEL": "Demo",
    "FREE_PLAY_VOUCHER_NAME_FPV": "FreePlay",
    "FREE_PLAY_VOUCHER_NAME_FSV": "Free Spins",
    "FREE_PLAY_VOUCHER_NAME_JPFPV": "Jackpot FreePlay",
    "FREE_PLAY_VOUCHER_NAME_JPFSV": "Jackpot Spins",
    "FREE_PLAY_VOUCHER_BALANCE_PREFIX": "Remaining:",
    "FREE_PLAY_VOUCHER_TITLE_FPV": "FreePlay Reward",
    "FREE_PLAY_VOUCHER_TITLE_FSV": "Free Spins Reward",
    "FREE_PLAY_VOUCHER_TITLE_JPFPV": "Jackpot FreePlay Reward",
    "FREE_PLAY_VOUCHER_TITLE_JPFSV": "Jackpot Spins Reward",
    "FREE_PLAY_VOUCHER_DESC_FPV": "Free play money to use on selected games in whichever way you wish!",
    "FREE_PLAY_VOUCHER_DESC_FSV": "Free Spins with pre-defined values to use on selected games!",
    "FREE_PLAY_VOUCHER_DESC_JPFPV": "Jackpot-only FreePlay money to use on selected games in whichever way you wish!",
    "FREE_PLAY_VOUCHER_DESC_JPFSV": "Jackpot-only Free Spins with pre-defined values to use on selected games!",
    "FREE_PLAY_VOUCHER_REWARD_AMOUNT": "{amount} {fp_voucher_name}",
    "FREE_PLAY_VOUCHER_REWARD_BALANCE": "{fp_voucher_remaining_prefix} {balance}",
    "FREE_PLAY_EXPIRES_IN_TIME": "Expires in {expiration}",
    "FREE_PLAY_EXPIRES_IN_EXPIRED": "Expired",
    "FREE_PLAY_EXPIRES_IN_DAY": "Expires in {expiration} days",
    "FREE_PLAY_MESSAGE_VOUCHER_TITLE_GOOD_LUCK": "Good Luck!",
    "FREE_PLAY_MESSAGE_LIST_TITLE": "You have rewards waiting for you. Good Luck!",
    "FREE_PLAY_MESSAGE_SELECTED_GAME_TITLE": "This game can also be played with the following rewards:",
    "FREE_PLAY_MESSAGE_GAMES_LIST_TITLE": "You can use this reward in the game(s) below.",
    "FREE_PLAY_MESSAGE_NO_VOUCHERS": "You have no rewards available",
    "FREE_PLAY_MESSAGE_BACK_TO_VOUCHERS": "Back",
    "FREE_PLAY_SHOW_MORE": "Show More",
    "FREE_PLAY_SHOW_LESS": "Show Less",
    "FREE_PLAY_USE_NOW_BUTTON": "Use Now",
    "FREE_PLAY_USE_LATER_BUTTON": "Use Later",
    "FREE_PLAY_SUGGESTION_DIALOG_TITLE": "You have rewards in this game!",
    "IDLE_RECOMMENDATIONS_TITLE": "Can’t decide what to play?",
    "IDLE_RECOMMENDATIONS_SECOND_TITLE": "You may like:",
    "BONUS_ABUSE_PREVENTION_TITLE": "Disconnected Game",
    "BONUS_ABUSE_PREVENTION_MESSAGE": "It looks like there's a game that was disconnected... Please complete {gameName} before you can start playing {newGameName}.",
    "BONUS_ABUSE_PREVENTION_NOT_NOW_BTN": "Not Now",
    "BONUS_ABUSE_PREVENTION_COMPLETE_BTN": "Complete Game",
    "OPEN_GAME_FROM_CHALLENGES": "Challenges can’t be completed using rewards.",
    "CANCEL": "Cancel",
    "YES": "Yes",
    "NO": "No",
    "ONE_GAME_PER_SESSION_DIALOG_TITLE": "Open Game",
    "ONE_GAME_PER_SESSION_DIALOG_MESSAGE": "It looks like there's a game that's still open....\nWould you like to close {oldGameName} and start playing {newGameName}?",
    "GAMES_OF_THE_WEEK": "Games Of The Week",
    "THE_FISH_MARKET": "The Fish Market",
    "LETS_PLAY_POKER": "Lets Play Poker!",
    "HYBRID_EMBEDDED_GAME_LOADING_SLOW_CONNECTION_TOASTER_TITLE": "Slow connection",
    "HYBRID_EMBEDDED_GAME_LOADING_SLOW_CONNECTION_TOASTER_SUBTITLE": "We've detected a slow network connection. Opening the game may take a little longer than expected.",
    "HYBRID_EMBEDDED_GAME_LOADING_SPINNER_LABEL": "Connecting...",
    "HYBRID_EMBEDDED_GAME_LOADING_PACKAGES_PROGRESS": "Preparing game {packagesStatus}",
    "HELP_CENTER": "Help Centre",
    "GEO_PERMISSIONS_POPUP_TITLE": "Location Check",
    "GEO_PERMISSIONS_POPUP_TOP_TEXT": "Allow location verification",
    "GEO_PERMISSIONS_POPUP_MIDDLE_TEXT": "We need your location to verify that playing is allowed in your province",
    "GEO_PERMISSIONS_BUTTON": "OK",
    "ABOUT_HELP_SUPPORT": "For any support queries, please visit our online\xa0help",
    "ABOUT_TITLE": "Your Account Details",
    "ABOUT_FISCAL_CODE_TITLE": "Fiscal Code",
    "ABOUT_SUPPORT_ID_TITLE": "ID for support",
    "ABOUT_CLIENT_VERSION_TITLE": "Client Version",
    "ABOUT_OPEN_SESSION_TITLE": "Open session balance",
  }
}